import React, { useEffect, useState } from "react";
import { Button, Descriptions, Flex, Image, Modal, notification, Switch, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";

function HeaderLogoContent({data, onUpdate, baseURL}) {
  const [logoOption, setLogoOption] = useState(data?.use_custom ? "custom" : "default");
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [isDeleteImage, setIsDeleteImage] = useState(false);

  const handlePreview = async (file) => {
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleLogoChange = (e) => {
    setLogoOption(e);
  };

  useEffect(() => {
    if (data?.custom_value) {
      setFileList([
        {
          uid: "-1",
          name: "custom_logo.png",
          status: "done",
          url: `${baseURL}/${data?.custom_value}`,
        },
      ]);
      setLogoOption(data?.use_custom ? "custom" : "default")
    }
  }, [data, baseURL]);

  const handleChange = ({ fileList }) => {
    // Manually set the preview image for the newly uploaded file
    setFileList(
      fileList.map((file) => ({
        ...file,
        preview:
          file.url ||
          (file.originFileObj && URL.createObjectURL(file.originFileObj)),
      }))
    );
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const handleSave = () => {
    let payload = {
      id: data?.id,
      use_custom : logoOption === "custom" ? true : false
    }
    if (fileList.length > 0 && fileList[0]?.originFileObj) {
      payload.image = fileList[0].originFileObj;
    }
    else if (logoOption === "custom" && fileList.length === 0){
      return notification.error({
        message: "Error",
        description:"Please Upload Custom Image",
        duration: 3,
      });
    }
    
    if (isDeleteImage) {
      payload.is_delete_image = true;
    }

    onUpdate(payload)
    setIsDeleteImage(false); // reset after saving
  }

  return (
    <div>
      <Descriptions column={2} bordered>
        <Descriptions.Item label="Default">
          <Image
            width={100}
            src={`${baseURL}${data?.default_value}`}
            alt="Default Logo"
            preview={{
              toolbarRender: () => null
            }}
          />
        </Descriptions.Item>

        <Descriptions.Item label="Custom">
          <Upload
            //   action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload" // <-- Replace with your API
            listType="picture-card"
            fileList={fileList}
            onPreview={handlePreview}
            onChange={handleChange}
            beforeUpload={() => false}
            maxCount={1}
            accept=".jpg,.jpeg,.png,.svg"
            onRemove={async (file) => {
              return new Promise((resolve, reject) => {
                Modal.confirm({
                  title: "Are you sure you want to delete this image?",
                  okText: "Yes",
                  cancelText: "No",
                  onOk: () => {
                    setIsDeleteImage(true); // track deletion
                    resolve(true);   // allow deletion
                  },
                  onCancel: () =>  resolve(false)
                });
              });
            }}
          >
            {fileList.length >= 1 ? null : uploadButton}
          </Upload>
          {previewImage && (
            <Image
              wrapperStyle={{ display: "none" }}
              preview={{
                visible: previewOpen,
                onVisibleChange: (visible) => setPreviewOpen(visible),
                afterOpenChange: (visible) => !visible && setPreviewImage(""),
                toolbarRender: () => null,
              }}
              src={previewImage}
            />
          )}
            <small>Recommended sizes: 200×50 px, 400×100 px</small><br/>
            <small>Aspect ratio:  4:1</small><br/>
            <small>File size:  20–60 KB</small>
        </Descriptions.Item>

        <Descriptions.Item label="Use Custom">
          <Switch
            checked={logoOption === "custom"}
            onChange={(checked) =>
              handleLogoChange(checked ? "custom" : "default")
            }
            checkedChildren="Custom"
            unCheckedChildren="Default"
          />
        </Descriptions.Item>
      </Descriptions>

      <Flex className="mt-5" justify="flex-end">
        <Button type="primary" onClick={handleSave}>Save</Button>
      </Flex>
    </div>
  );
}

export default HeaderLogoContent;
